export const modes = {
  EDIT: 'edit',
  VIEW: 'view',
  CREATE: 'create',
}
export const paneModes = {
  TYPESELECT: 'typeSelect',
  PRODUCTSELECT: 'productSelect',
  SUPPLYFILTERS: 'supplyFilters',
  TANKIMPACT: 'tankImpact',
}
export const orderTypes = {
  BACKHAUL: 'backhaul',
  STOREDELIVERY: 'storeDelivery',
}
